import { ApolloLink } from "@apollo/client";
import { createContext, ReactNode, useContext, useEffect, useState } from "react";

type DbNameContext = {
  dbName: string;
};

export const DbNameContext = createContext<DbNameContext>({
  dbName: ""
});

export function DbNameContextProvider({ children }: { children: ReactNode }) {
  const [dbName, setDbName] = useState<string>("");

  useEffect(() => {
    window.addEventListener("dbName", (ev: CustomEvent) => {
      setDbName(ev.detail);
    });
  }, []);

  return <DbNameContext.Provider value={{ dbName }}>{children}</DbNameContext.Provider>;
}

export const useDbName = () => {
  return useContext(DbNameContext)?.dbName ?? "";
};

export const dbNameLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((response) => {
    const context = operation.getContext();
    const responseObj = context.response;

    if (responseObj && responseObj.headers) {
      // Example: read custom header
      const dbName = responseObj.headers.get("x-db-name");

      if (dbName) {
        window.dispatchEvent(new CustomEvent("dbName", { detail: dbName }));
      }
    }

    return response;
  });
});
